import React from 'react';

interface NoteTextProps {
  text?: string | null;
  maxLength?: number;
}

/**
 * Displays note text with truncation.
 */
export const NoteText: React.FC<NoteTextProps> = ({ text, maxLength = 50 }) => {
  if (!text) return <div></div>;
  
  const truncated = text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  
  return <div title={text}>{truncated}</div>;
};

/** Syncfusion grid template wrapper */
export const noteTextTemplate = (props: { text?: string | null }) => (
  <NoteText text={props.text} />
);

export default NoteText;
